export default {"src":"/_next/static/media/purchasesIcon.26d3df66.svg","height":24,"width":24};